export const JOURNEY_ORIENTATION_FROM = "JOURNEY_ORIENTATION_FROM";
export const JOURNEY_ORIENTATION_TO = "JOURNEY_ORIENTATION_TO";
